import React from 'react';
import Result from '../../Components/powerbiModule/Result';

const PowerBIModule = () => {
  return (
    <Result />
  );
};

export default PowerBIModule;
